import React, { useEffect, useState } from "react";
import {
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import "./ContactUs.css";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { siteSettings } from "../../Data/axios";
import Banner from "../../Components/Banner";

const ContactUs = () => {
  const [siteData, setSiteData] = useState({}); // Initialize as an empty object
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const data = await siteSettings.getSettingsForWebsite();
        setSiteData(data || {});
      } catch (err) {
        setError(err.message || "Failed to fetch site data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, {});
  return (
    <div>
      <Header />
      <div className="contact-us bg-topo-bg font-ubuntu">
        {/* <div className="contact-header">
          <h1>Contact Us</h1>
          <p>We'd love to hear from you! Reach out to us through any of the following ways.</p>
        </div> */}
        <Banner
          imageUrl="./banner1.svg"
          title="Contact Us"
          subtitle="We'd love to hear from you! Reach out to us through any of the following ways."
        />

        <div className="grid grid-cols-6 grid-rows-5 p-16 gap-4 max-md:flex max-md:flex-col">
          <div className="col-span-3">
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div className="text-center">
                <h3>Email</h3>
                <p>info@roadpilot.co.in</p>
              </div>
            </div>
          </div>
          <div className="col-span-3 col-start-4">
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div className="text-center">
                <h3>Phone</h3>
                <p>1800-571-55-99</p>
              </div>
            </div>
          </div>
          <div className="col-span-3 row-start-2">
            
            <div className="contact-item social-icons-card">
              <h3>Follow Us</h3>
              <div className="social-icons">
                <a
                  href={siteData.site_twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1DA1F2" }}
                >
                  <FaTwitter />
                </a>
                <a
                  href={siteData.site_instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#E1306C" }}
                >
                  <FaInstagram />
                </a>
                <a
                  href={siteData.site_youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#FF0000" }}
                >
                  <FaYoutube />
                </a>
                <a
                  href={siteData.site_whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#25D366" }}
                >
                  <FaWhatsapp />
                </a>
              </div>
            </div>
          </div>
          <div className="col-span-3 row-span-4 col-start-1 row-start-4">
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div className="map-container">
                <h3>Map Location</h3>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.2306272737546!2d80.90250947494249!3d26.768917466256294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb53706b7d85%3A0xa2330944dc4c56e4!2sRoad%20Pilot%20technologies%20pvt%20ltd!5e0!3m2!1sen!2sin!4v1744038825734!5m2!1sen!2sin"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="col-span-3 row-span-6 col-start-4 row-start-2">
            <div className="bg-white rounded-lg p-10 shadow-md h-full font-ubuntu">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                Contact Us
              </h2>
              <form>
                <div className="mb-4">
                  <label className="block text-gray-800 mb-1" htmlFor="name">
                    Your Name
                  </label>
                  <input
                    className="w-full px-4 py-2 bg-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-csgreen-300 transition duration-300"
                    placeholder="Enter your name"
                    type="text"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-800 mb-1" htmlFor="email">
                    Your Email
                  </label>
                  <input
                    className="w-full px-4 py-2 bg-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-csgreen-300 transition duration-300"
                    placeholder="Enter your email"
                    name="email"
                    id="email"
                    type="email"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-800 mb-1" htmlFor="message">
                    Your Message
                  </label>
                  <textarea
                    className="w-full px-4 py-2 bg-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-csgreen-300 transition duration-300"
                    rows={4}
                    placeholder="Enter your message"
                    name="message"
                    id="message"
                    defaultValue={""}
                  />
                </div>
                <button
                  className="w-full bg-csyellow text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-400 transition duration-300"
                  type="submit"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className="col-span-3 col-start-1 row-start-3">
          <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div className="text-center">
                <h3>Address</h3>
                <p>E-1475 OMAXE CITY, R. B. ROAD LUCKNOW</p>
                <p>Lucknow UP 226002 IN</p>
                <p>India</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
